import React from "react";
import DeviceIdentifier from "./deviceIdentifier";

function CustomDisplay({ children, ...props }) {
  return <DeviceIdentifier {...props}>{children}</DeviceIdentifier>;
}

function DesktopTabletOnly({ children }) {
  return (
    <DeviceIdentifier isDesktop={true} isTablet={true}>
      {children}
    </DeviceIdentifier>
  );
}

function DesktopOnly({ children }) {
  return <DeviceIdentifier isDesktop={true}>{children}</DeviceIdentifier>;
}

function MobileOnly({ children }) {
  return <DeviceIdentifier isMobile={true}>{children}</DeviceIdentifier>;
}

function SmallMobileOnly({ children }) {
  return <DeviceIdentifier isTiny={true}>{children}</DeviceIdentifier>;
}

function MobileTabletOnly({ children }) {
  return (
    <DeviceIdentifier isMobile={true} isTablet={true}>
      {children}
    </DeviceIdentifier>
  );
}

function TabletOnly({ children }) {
  return <DeviceIdentifier isTablet={true}>{children};</DeviceIdentifier>;
}

export {
  DesktopOnly,
  MobileOnly,
  TabletOnly,
  DesktopTabletOnly,
  MobileTabletOnly,
  SmallMobileOnly,
  CustomDisplay
};
